import styles from 'client/pages/MapPage/components/MapMenu/AssetInfo/AssetInfo.module.scss';
import PropTypes from 'prop-types';
import defaultAriaProps from 'client/utils/constants/ariaPropTypes';

const AssetInfo = ({ children, title, icon, ...props }) => {
    return (
        <div {...props}>
            { title
                ? <h2
                    data-testid={props['data-testid'] ? props['data-testid'] + '.title' : null}
                    className="govuk-caption-m govuk-!-font-size-14 govuk-!-margin-bottom-1"
                >
                    {title}
                </h2>
                : null
            }
            <div
                className={styles.content}
            >
                { icon
                    ? <div
                        data-testid={props['data-testid'] ? props['data-testid'] + '.icon' : null}
                        className={styles.icon}
                    >
                        {icon}
                    </div>
                    : null
                }
                <div
                    className={[
                        'govuk-body-m govuk-!-font-weight-bold govuk-!-margin-bottom-0',
                        icon ? styles.icon : null
                    ].join(' ')}
                >
                    {children}
                </div>
            </div>
        </div>
    );
};

AssetInfo.propTypes = {
    ...defaultAriaProps,
    title: PropTypes.any,
    icon: PropTypes.element
};

export default AssetInfo;
